import * as React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { AppView, AppMainView } from '../../../../../components/AppView'
import { InvoiceHeader } from '../Header/InvoiceHeader'
import { CreateInvoiceList } from '../..'
import { Filter } from '../../FilterStore'
import { Skeleton } from 'antd'
import { InvoiceTable } from './InvoiceTable'
import AppPagination from '../../../../../components/Pagination/index'
import AppHeader from '../../../../../components/AppView/Header'
import { InvoiceListFilter } from './InvoiceListFilter'
import Helmet from 'react-helmet'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { Routes } from '../../../../../constants/Routes'
import { Link } from 'react-router'
import { ArrowRightOutlined } from '@ant-design/icons'
import { Alert } from 'antd-v4'

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

interface Props {
  createInvoiceList: CreateInvoiceList
  invoiceFilter: Filter
  isLoading: boolean
  loadInvoices: (offset?: number) => void
}

export const InvoiceListComponent = (props: Props & InjectedProps) => {
  const { createInvoiceList, invoiceFilter, isLoading, loadInvoices } = props

  const company = props.currentCompanyStore?.company
  if (!company) return null

  const onPageChange = async ({ selected }: { selected: number }) => {
    await loadInvoices(selected * createInvoiceList.invoiceCountPerPage)
  }

  return (
    <AppView column>
      <Helmet>
        <title>Purchase orders | Purchase order list</title>
        <meta name='page-loaded' content='true' />
      </Helmet>

      <AppHeader title='Purchase orders'>
        <InvoiceHeader createInvoiceList={createInvoiceList} invoiceFilter={invoiceFilter} />
      </AppHeader>

      <AppMainView className='background-grey mb-4'>
        <Alert
          className='mb-2'
          style={{ marginTop: -8 }}
          message={
            <Link
              to={Routes.DASHBOARD_SAMPLE_DIRECT(company?.id)}
              style={{ color: 'black', textDecorationLine: 'underline' }}
            >
              Check out the latest samples
              <ArrowRightOutlined style={{ marginLeft: '6px' }} />
            </Link>
          }
          type='success'
        />

        <div className='d-flex flex-wrap space-evenly white-rounded-container pb-0'>
          <InvoiceListFilter invoiceFilter={invoiceFilter} loadInvoices={loadInvoices} />
        </div>

        {isLoading ? (
          <Skeleton active />
        ) : (
          <InvoiceTable createInvoiceList={createInvoiceList} invoiceFilter={invoiceFilter} />
        )}
      </AppMainView>

      <AppPagination
        currentPage={createInvoiceList.currentPage}
        pageCount={createInvoiceList.numberOfPages}
        onPageChange={onPageChange}
      />
    </AppView>
  )
}

export const InvoiceList = inject('currentCompanyStore')(observer(InvoiceListComponent))
